import {
    PaginationState,
    createColumnHelper,
    flexRender,
    getCoreRowModel,
    getSortedRowModel,
    SortingState,
    useReactTable,
  } from "@tanstack/react-table";
  import Card from "components/card";
  import DivLoader from "components/divloader/DivLoader";
  import React, { useEffect, useState } from "react";
  import { ClientRowObj } from "..";
  import Searchbox from "components/fields/Searchbox";
  import Pagination from "components/pagination";
import ShortTruncateCopy from "components/common/ShortTruncateCopy";
import moment from "moment"; 
import { AiFillMinusCircle, AiFillPlusCircle } from "react-icons/ai";
import { getAllGatewaysSecond } from "api/graphQL_gateways";
import { uploadKycDocument } from "api/graphQL_customers";
import visa from "assets/svg/card_type/visa.svg";
import MasterCard from "assets/svg/card_type/mastercard.svg";
import Discover from "assets/svg/card_type/discover.svg";
import Amex from "assets/svg/card_type/amex.svg";
import MaestroCard from "assets/svg/card_type/maestro.svg";
import DinersClub from "assets/svg/card_type/dinersclub.svg";
import JCB from "assets/svg/card_type/jcb.svg";
import UnionPay from "assets/svg/card_type/unionpay.svg";
import { convertToFloat } from "utils/formatNumber";
import StatusRender from "views/admin/payments/components/StatusRender";
import AdvancedInfoModal from "views/admin/payments/components/AdvancedInfoModal";
import CustomToolTip from "components/tooltips";
import { BsArrowDown, BsArrowUp } from "react-icons/bs";
import { RiArrowUpDownFill } from "react-icons/ri";
import { FiCheckCircle, FiEye, FiUpload } from "react-icons/fi";
import toast from "react-hot-toast";
import { Popover, PopoverTrigger, PopoverContent, PopoverHeader , PopoverArrow } from "@chakra-ui/react";
import { Portal } from '@chakra-ui/portal'

  function CustomerTable(props: {
    tableData: any;
    fetchClients: () => void;
    isLoading: boolean;
    roleData?: any;
    page: number;
    setPage: any;
    totalpage: number;
    totalItems: number;
    currentPage: number;
    pageSize: number;
    setPageSize: any;
    allGateways: any;
    onValueChange: (value: string) => void;
  }) {
    const {
      tableData,
      fetchClients,
      roleData,
      page,
      setPage,
      currentPage,
      totalpage,
      totalItems,
      pageSize,
      setPageSize,
      allGateways,
      onValueChange,
      isLoading
    } = props;
    let defaultData = tableData;
  
    const [{ pageIndex }, setPagination] = React.useState<PaginationState>({
      pageIndex: 0,
      pageSize,
    });

    const [expandedRow, setExpandedRow] = useState<string | null>(null);
  
    const pagination = React.useMemo(() => ({
      pageIndex,
      pageSize,
    }), [pageIndex, pageSize],
    );

    const handleExpand = (rowId : any) => {
      setExpandedRow(expandedRow === rowId ? null : rowId);
    };
  
    const columns = [
      columnHelper.accessor("created_at", {
        id: "created_at",
        header: () => (
            <p className="text-sm font-bold text-gray-900 dark:text-white">Created Date</p>
        ),
        cell: (info : any) => {
            const rawDate = info.getValue();
            const formattedDate = moment(rawDate).format("YYYY-MM-DD HH:mm:ss");
    
            return (
              <p
                className="text-sm font-bold text-navy-700 dark:text-white flex items-center gap-1 cursor-pointer"
                onClick={() =>
                  handleExpand(info?.row?.original?.customer_id)
                }
              >
                
                  {expandedRow === info?.row?.original?.customer_id ? (
                    <AiFillMinusCircle className="w-5 h-5 text-navy-700 dark:text-white" />
                  ) : (
                    <AiFillPlusCircle className="w-5 h-5 text-navy-700 dark:text-white" />
                  )}
              
                {formattedDate}
              </p>
            );
        },  
        size: 200, 
        minSize: 200,
        maxSize: 300, 
      }),
      columnHelper.accessor("customer_id", {
        id: "customer_id",
        header: () => (
          <p className="text-sm font-bold text-gray-900 dark:text-white">CUSTOMER ID</p>
        ),
        cell: (info: any) => {
            return <>
              <ShortTruncateCopy info={info?.getValue()} showCopy={true} />
            </>
          },
      }),
      columnHelper.accessor("first_name", {
        id: "first_name",
        header: () => (
          <p className="text-sm font-bold text-gray-900 dark:text-white">NAME</p>
        ),
        cell: (info: any) => {
            return (
                <>
                    <div className="flex items-center">
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                        {info?.row?.original?.first_name} {info?.row?.original?.last_name}
                        </p>
                    </div>   
                </> 
            )
        },
      }),
      columnHelper.accessor("email", {
        id: "email",
        header: () => (
          <p className="text-sm font-bold text-gray-900 dark:text-white">Email</p>
        ),
        cell: (info) => (
            <p className="text-sm font-bold text-navy-700 dark:text-white">
              <a href={`mailto:${info.getValue()}`}> {info.getValue()}</a>
            </p>
        ),
      }),
      columnHelper.accessor("phone", {
        id: "phone",
        header: () => (
          <p className="text-sm font-bold text-gray-900 dark:text-white">PHONE</p>
        ),
        cell: (info) => (
          <p className="text-sm font-bold text-navy-700 dark:text-white">
            <a href={`tel:${info.getValue()}`}> {info.getValue()}</a>
            {/* {info.getValue()} */}
          </p>
        ),
      }),
      columnHelper.accessor("source_client", {
        id: "source_client",
        header: () => (
          <p className="text-sm font-bold text-gray-900 dark:text-white">SOURCE CLIENT</p>
        ),
        cell: (info: any) => {
            return <>
                <div className="flex items-center">
                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                        {info?.getValue()}
                    </p>
                </div>
            </>
        },
      }),
      columnHelper.accessor("total_transactions", {
        id: "total_transactions",
        header: () => (
          <p className="text-sm font-bold text-gray-900 dark:text-white">Transactions</p>
          // <p className="text-sm font-bold text-gray-900 dark:text-white">Number of Transaction</p>
        ),
        cell: (info: any) => {
            return <>
                <div className="flex items-center">
                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                      {info?.getValue()}
                    </p>
                </div>
            </>
        },
      }),
    ]; 
  
    const [sorting, setSorting] = React.useState<SortingState>([]);
    const [data, setData] = React.useState(() => [...defaultData]);
    const [searchVal, setSearchVal] = useState<any>("");
    const [searchGateTexts, setSearchTexts] = useState<string>("");
    const [paymentData, setPaymentData] = useState<any[]>([]);
    const [activeGatewayTransactions, setActiveGatewayTransactions] = useState("");
    const [activePaymentMethod, setActivePaymentMethod] = useState("");
    const [uploadingKYC,setUploadingKYC] = useState("")
    
    useEffect(() => {
      getAllGatewaysSecond(searchGateTexts)
        .then((data) => {
          setPaymentData(data ?? []);
        })
        .catch((err) => {
        
        })
        .finally(() => {
          
        });

      const processedData = tableData.map((item: any) => {
        let transactions = [];
        if (Array.isArray(item.transactionsList)) {
          try {
            transactions = item.transactionsList.map((txn: string) => JSON.parse(txn));

            const groupedTransactions = transactions.reduce((acc: Record<string, any[]>, txn : any) => {
              if (!txn.gateway_id) return acc;
              
              if (!acc[txn.gateway_id]) {
                acc[txn.gateway_id] = [];
              }
        
              acc[txn.gateway_id].push(txn);
              return acc;
            }, {});

            transactions = groupedTransactions
          } catch (error) {
          }
        }

        let payment_methods = [];
        if (Array.isArray(item.paymentMethods)) {
          try {
            payment_methods = item.paymentMethods.map((txn: string) => JSON.parse(txn));

            const groupedPaymentMethods = payment_methods.reduce((paymeth: Record<string, any[]>, pm : any) => {
              if (!pm.type) return paymeth;
              
              if (!paymeth[pm.type]) {
                paymeth[pm.type] = [];
              }
        
              paymeth[pm.type].push(pm);
              return paymeth;
            }, {});

            payment_methods = groupedPaymentMethods
          } catch (error) {
          }
        }

        let kyc = [];
        if (Array.isArray(item.kyc)) {
          try {
            kyc = item.kyc.map((txn: string) => JSON.parse(txn));
            kyc = kyc
          } catch (error) {
          }
        }
    
        return {
          ...item,
          transactionsList: transactions,
          paymentMethods:payment_methods,
          kyc:kyc
        };
      });
      setData(processedData);
    }, [tableData]);
    
    const table = useReactTable({
      data,
      columns: columns,
      state: {
        pagination,
        sorting,
      },
      onPaginationChange: setPagination,
      onSortingChange: setSorting,
      getCoreRowModel: getCoreRowModel(),
      getSortedRowModel: getSortedRowModel(),
      debugTable: true,
    });
  
    const handleValueChange = (e: any) => {
  
      onValueChange(e);
      setSearchVal(e);
    };

    const getGatewayName = (id: any) => {
      const gateway = paymentData.find((item) => item.id === id);
      return gateway ? gateway.name : "Unknown";
    };

    const getCardSVG = (type: string) => {
        switch (type) {
          case "VISA":
            return (
              <img
                className=""
                style={{ maxWidth: "65px" }}
                title={type}
                src={`${visa}`}
                alt={`${type}`}
              />
            );
          case "MasterCard":
            return (
              <img
                style={{ maxWidth: "65px" }}
                title={type}
                src={`${MasterCard}`}
                alt={`${type}`}
              />
            );
          case "Discover":
            return (
              <img
                style={{ maxWidth: "65px" }}
                title={type}
                src={`${Discover}`}
                alt={`${type}`}
              />
            );
          case "Amex":
            return (
              <img
                style={{ maxWidth: "65px" }}
                title={type}
                src={`${Amex}`}
                alt={`${type}`}
              />
            );
          case "MaestroCard":
            return (
              <img
                style={{ maxWidth: "65px" }}
                title={type}
                src={`${MaestroCard}`}
                alt={`${type}`}
              />
            );
          case "DinersClub":
            return (
              <img
                style={{ maxWidth: "65px" }}
                title={type}
                src={`${DinersClub}`}
                alt={`${type}`}
              />
            );
          case "JCB":
            return (
              <img
                style={{ maxWidth: "65px" }}
                title={type}
                src={`${JCB}`}
                alt={`${type}`}
              />
            );
          case "UnionPay":
            return (
              <img
                style={{ maxWidth: "65px" }}
                title={type}
                src={`${UnionPay}`}
                alt={`${type}`}
              />
            );
    
          default:
            return "-";
        }
    };

    const cardPatterns: { [key: string]: RegExp } = {
      VISA: /^4[0-9]{12}(?:[0-9]{3})?$/,
      MasterCard: /^5[1-5][0-9]{14}$|^2[2-7][0-9]{14}$/,
      Discover: /^6(?:011|5[0-9]{2})[0-9]{12}$/,
      Amex: /^3[47][0-9]{13}$/,
      MaestroCard: /^(5018|5020|5038|5893|6304|6759|6761|6762|6763)[0-9]{8,15}$/,
      DinersClub: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
      JCB: /^(?:2131|1800|35[0-9]{3})[0-9]{11}$/,
      UnionPay: /^62\d{12,19}$/
    };

    const getCardType = (cardNumber: string): string => {
      const cleaned = cardNumber.replace(/\D/g, ""); 
    
      for (const [cardType, pattern] of Object.entries(cardPatterns)) {
        if (pattern.test(cleaned)) {
          return cardType;
        }
      }
    
      return "Unknown";
    };

    const openGatewayTransactions = (value : any) => {
      setActiveGatewayTransactions(activeGatewayTransactions === value ? null : value);
    }

    const openPaymentMethods = (value : any) => {
      setActivePaymentMethod(activePaymentMethod === value ? null : value);
    }

    const handleFileChange = async (event : any, kycId : any,customerId : any) => {
      const file = event.target.files[0];
      if (!file) return;
      const allowedTypes = ["image/png","image/jpg","image/jpeg", "image/svg","image/svg+xml"];
      if (allowedTypes.includes(file.type)) {
         setUploadingKYC(kycId)
          const reader: FileReader = new FileReader();
          reader.readAsDataURL(file);
          reader.onloadend = async () => {
              const fileUrl = reader.result as string;
              const params = { customer_id: customerId, kyc_id: kycId, document: fileUrl };
              await uploadKycDocument(params)
              .then((data:any) => { 
                setUploadingKYC("")
                toast.success(data.message ?? "Document Uploaded Successfully");
                fetchClients()
              })
              .catch((err) => {})
              .finally(() => {});
          };
      } else {
          toast.error("Only PNG and SVG files are allowed.");
      }
    }
    

    return (
      <Card extra={"w-full h-full sm:overflow-auto px-6"}>
        {/* <header className="relative flex items-center justify-between pt-5"> */}
        <header className="relative flex items-center justify-between pt-5 flex-wrap">
          <div className="text-xl font-bold text-navy-700 dark:text-white">
            All Customers
          </div>
          <Searchbox onSearch={handleValueChange} />
        </header>
  
        <div className="mt-4  overflow-x-auto scrollbar scrollbar-track-gray-100 scrollbar-thumb-gray-300 scrollbar-track-rounded-full scrollbar-thumb-rounded-xl scrollbar-h-1.5 relative overflow-x-auto shadow-md sm:rounded-lg">
          {props.isLoading ? (
            <DivLoader className="m-5 h-6 w-6 border-indigo-500" />
          ) : (
            <table className="w-full w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 ">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 ">
                {table.getHeaderGroups().map((headerGroup) => (
                  <tr
                    key={headerGroup.id}
                    className=""
                  >
                    {headerGroup.headers.map((header) => {
                      return (
                        <th
                          key={header.id}
                          colSpan={header.colSpan}
                          onClick={header.column.getToggleSortingHandler()}
                          className="cursor-pointer border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2"
                        >
                          <div className="flex items-center text-xs text-gray-200">
                            {flexRender(header.column.columnDef.header, header.getContext())}
                            <span className="ml-2">
                              {header.column.getIsSorted() === "asc" ? (
                                <BsArrowUp size={14} className="text-gray-900"/>
                              ) : header.column.getIsSorted() === "desc" ? (
                                <BsArrowDown size={14} className="text-gray-900"/>
                              ) : (
                                <RiArrowUpDownFill size={14} className="text-gray-900"/>
                              )}
                            </span>
                          </div>
                        </th>
                      );
                    })}
                  </tr>
                ))}
              </thead>
              <tbody >
                {(table.getRowModel().rows?.length > 0) ? table.getRowModel().rows.map((row) => {
                  return (
                    <React.Fragment key={row.id}>
                      <tr key={row.id} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 ">
                        {row.getVisibleCells().map((cell) => {
                          return (
                            <td
                              key={cell.id}
                              className="min-w-[150px] border-white/0 py-3  pr-4 p-2 font-bold text-gray-900"
                            >
                              {flexRender(
                                cell.column.columnDef.cell,
                                cell.getContext()
                              )}
                            </td>
                          );
                        })}
                      </tr>
                      {expandedRow === row.original.customer_id && (
                        <tr className="bg-gray-100">
                          <td colSpan={columns.length} className="p-4 border">
                            <div className="space-y-2">
                            
                              <>
                              <h4 className="font-bold text-navy-700">Source Client</h4>
                              <div className="border rounded-lg p-3 bg-white shadow">
                                <table className="w-full w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 ">
                                  <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 ">
                                    <tr>
                                      <th className="border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2">
                                        <div className="items-center justify-between text-xs text-gray-200 ">
                                          <p className="text-sm font-bold text-gray-900 dark:text-white">Client</p>
                                        </div>
                                      </th>
                                      <th className="border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2">
                                        <div className="items-center justify-between text-xs text-gray-200 ">
                                          <p className="text-sm font-bold text-gray-900 dark:text-white">Reference ID</p>
                                        </div>
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody >
                                    <tr  className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 ">
                                      <td className="min-w-[150px] border-white/0 py-3  pr-4 p-2 font-bold text-gray-900">
                                        {row.original.source_client}
                                      </td>
                                      <td className="min-w-[150px] border-white/0 py-3  pr-4 p-2 font-bold text-gray-900">
                                        {row.original.reference_id}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                              <h4 className="font-bold text-navy-700">Gateways</h4>
                              {Object.keys(row.original.transactionsList).length > 0 ? (
                                <div className="border rounded-lg p-3 bg-white shadow">
                                  <table className="w-full w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 ">
                                    <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 ">
                                      <tr>
                                        <th className="border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2">
                                          <div className="items-center justify-between text-xs text-gray-200 ">
                                            <p className="text-sm font-bold text-gray-900 dark:text-white">Gateway Name</p>
                                          </div>
                                        </th>
                                        <th className="border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2">
                                          <div className="items-center justify-between text-xs text-gray-200 ">
                                            <p className="text-sm font-bold text-gray-900 dark:text-white">Customer Id</p>
                                          </div>
                                        </th>
                                        <th className="border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2">
                                          <div className="items-center justify-between text-xs text-gray-200 ">
                                            <p className="text-sm font-bold text-gray-900 dark:text-white">No Of Transactions</p>
                                          </div>
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody >
                                      {Object.entries(row.original.transactionsList).map(([gatewayId, transactions]: [string, any]) => (
                                        <React.Fragment key={gatewayId}>
                                          <tr key={gatewayId}  className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 ">
                                            <td className="min-w-[150px] border-white/0 py-3  pr-4 p-2 font-bold text-gray-900">
                                              <div className="flex items-center gap-2 cursor-pointer" onClick={() => openGatewayTransactions(gatewayId + ":" + row.original.customer_id)}>
                                                {activeGatewayTransactions === (gatewayId + ":" + row.original.customer_id) ? (
                                                  <>
                                                    <AiFillMinusCircle className="w-5 h-5 text-navy-700 dark:text-white" /> {getGatewayName(gatewayId)}
                                                  </>
                                                ) : (
                                                  <>
                                                    <AiFillPlusCircle className="w-5 h-5 text-navy-700 dark:text-white" /> {getGatewayName(gatewayId)}
                                                  </>
                                                )}
                                              </div>
                                            </td>
                                            <td className="min-w-[150px] border-white/0 py-3  pr-4 p-2 font-bold text-gray-900">
                                              -
                                            </td>
                                            <td className="min-w-[150px] border-white/0 py-3  pr-4 p-2 font-bold text-gray-900">
                                              {transactions.length}
                                            </td>
                                          </tr>
                                          {activeGatewayTransactions === (gatewayId + ":" + row.original.customer_id) && (
                                              <tr>
                                                <td colSpan={3} className="p-4 text-gray-900 dark:text-white">
                                                  <div className="space-y-2">
                                                    <table className="w-full w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 ">
                                                      <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 ">
                                                        <tr>
                                                          <th className="border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2">
                                                            <div className="items-center justify-between text-xs text-gray-200 ">
                                                              <p className="text-sm font-bold text-gray-900 dark:text-white">Date</p>
                                                            </div>
                                                          </th>
                                                          <th className="border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2">
                                                            <div className="items-center justify-between text-xs text-gray-200 ">
                                                              <p className="text-sm font-bold text-gray-900 dark:text-white">Amount</p>
                                                            </div>
                                                          </th>
                                                          <th className="border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2">
                                                            <div className="items-center justify-between text-xs text-gray-200 ">
                                                              <p className="text-sm font-bold text-gray-900 dark:text-white">Transaction ID</p>
                                                            </div>
                                                          </th>
                                                          <th className="border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2">
                                                            <div className="items-center justify-between text-xs text-gray-200 ">
                                                              <p className="text-sm font-bold text-gray-900 dark:text-white">Internal ID</p>
                                                            </div>
                                                          </th>
                                                          <th className="border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2">
                                                            <div className="items-center justify-between text-xs text-gray-200 ">
                                                              <p className="text-sm font-bold text-gray-900 dark:text-white">Gateway Name</p>
                                                            </div>
                                                          </th>
                                                          <th className="border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2">
                                                            <div className="items-center justify-between text-xs text-gray-200 ">
                                                              <p className="text-sm font-bold text-gray-900 dark:text-white">DESCRIPTOR</p>
                                                            </div>
                                                          </th>
                                                          <th className="border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2">
                                                            <div className="items-center justify-between text-xs text-gray-200 ">
                                                              <p className="text-sm font-bold text-gray-900 dark:text-white">Card Type</p>
                                                            </div>
                                                          </th>
                                                          <th className="border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2">
                                                            <div className="items-center justify-between text-xs text-gray-200 ">
                                                              <p className="text-sm font-bold text-gray-900 dark:text-white">Status</p>
                                                            </div>
                                                          </th>
                                                          <th className="border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2">
                                                            <div className="items-center justify-between text-xs text-gray-200 ">
                                                              <p className="text-sm font-bold text-gray-900 dark:text-white">Action</p>
                                                            </div>
                                                          </th>
                                                        </tr>
                                                      </thead>
                                                      <tbody >
                                                        {transactions.map((transaction : any, index : any) => (
                                                          <tr key={index} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 ">
                                                            <td className="min-w-[150px] border-white/0 py-3  pr-4 p-2 font-bold text-gray-900">{moment(transaction.created_at).format("YYYY-MM-DD HH:mm:ss")}</td>
                                                            <td className="min-w-[150px] border-white/0 py-3  pr-4 p-2 font-bold text-gray-900 uppercase">
                                                              {convertToFloat(transaction.amount)} {transaction.currency }
                                                              {transaction?.converted_amount &&
                                                              transaction?.converted_currency && (
                                                                <span>
                                                                  {` (${transaction?.converted_amount} ${transaction?.converted_currency})`}
                                                                </span>
                                                              )}
                                                            </td>
                                                            <td
                                                            className="min-w-[150px] border-white/0 py-3  pr-4 p-2 font-bold text-gray-900">
                                                              <ShortTruncateCopy info={transaction?.et_id} showCopy={true} />
                                                            </td>
                                                            <td className="min-w-[150px] border-white/0 py-3  pr-4 p-2 font-bold text-gray-900">
                                                              <ShortTruncateCopy info={transaction?.id} showCopy={true} />
                                                            </td>
                                                            <td className="min-w-[150px] border-white/0 py-3  pr-4 p-2 font-bold text-gray-900">
                                                              {getGatewayName(transaction.gateway_id)}
                                                            </td>
                                                            <td className="min-w-[150px] border-white/0 py-3  pr-4 p-2 font-bold text-gray-900">
                                                              {transaction?.meta_info?.Descriptor}
                                                            </td>
                                                            <td className="min-w-[150px] border-white/0 py-3  pr-4 p-2 font-bold text-gray-900">
                                                              {transaction?.meta_info?.binInformation
                                                              ? getCardSVG(transaction?.meta_info?.binInformation?.card_type)
                                                              : "-"}
                                                            </td>
                                                            <td className="min-w-[150px] border-white/0 py-3  pr-4 p-2 font-bold text-gray-900">
                                                            <div className="flex items-center gap-1.5 text-sm font-bold">
                                                                {/* <StatusRender
                                                                  status={transaction?.status}
                                                                  value={transaction?.status}
                                                                />  */}

                                                                <CustomToolTip
                                                                  content={
                                                                    transaction?.payment_history?.length > 0 ? (
                                                                      transaction?.payment_history?.map(
                                                                        (hisData: any, index: number) => {
                                                                          let errorMessage = ""
                                                                          if(transaction?.status == 'DECLINED' || transaction?.status == 'ERRORED' || transaction?.status == 'FAILED') {
                                                                            const gatewayResponse = transaction?.gateway_response?.gateway_response;
                                                                            const errorKeys = ["errorMessage", "message", "decline_reason","error_message"];
                                                                            const findLastErrorMessage = (obj: any): string | null => {
                                                                              let lastValue: string | null = null;
                                                                            
                                                                              const search = (data: any) => {
                                                                                if (!data || typeof data !== "object") return;
                                                                            
                                                                                for (const key of Object.keys(data)) {
                                                                                  if (errorKeys.includes(key) && key !== "_content") {
                                                                                    lastValue = data[key]; // Store the last found error message
                                                                                  }
                                                                            
                                                                                  // Recursively search inside nested objects
                                                                                  if (typeof data[key] === "object") {
                                                                                    search(data[key]);
                                                                                  }
                                                                            
                                                                                  // Special handling for `_content`
                                                                                  if (key === "_content" && typeof data[key] === "string") {
                                                                                    try {
                                                                                      const parsedContent = JSON.parse(data[key]);
                                                                            
                                                                                      // Check for `decline_reason` inside the parsed content
                                                                                      if (parsedContent.decline_reason) {
                                                                                        lastValue = parsedContent.decline_reason;
                                                                                      } else {
                                                                                        // If `decline_reason` is not found, check for other error keys
                                                                                        for (const parsedKey of Object.keys(parsedContent)) {
                                                                                          if (errorKeys.includes(parsedKey)) {
                                                                                            lastValue = parsedContent[parsedKey];
                                                                                          }
                                                                                        }
                                                                                      }
                                                                                    } catch (error) {
                                                                                    }
                                                                                  }
                                                                                }
                                                                              };
                                                                            
                                                                              search(obj);
                                                                              return lastValue;
                                                                            };
                                                                            
                                                                            
                                                                            const lastError = findLastErrorMessage(gatewayResponse);
                                                                            errorMessage = typeof lastError === "string" ? lastError : "";

                                                                          
                                                                          }
                                                                          return (
                                                                            <>
                                                                              <Card className="m-2 shadow " key={index}>
                                                                                <div className="border-1 max-w-[70vh] border  border-white  p-3">
                                                                                  {index == 0 && (
                                                                                    <p className="">
                                                                                      Created at {hisData?.created_at} by API
                                                                                      call from [{hisData?.client}
                                                                                      {" - "}
                                                                                      {hisData?.ip}] with status{" "}
                                                                                      {hisData?.status}

                                                                                      {["DECLINED", "ERRORED", "FAILED"].includes(hisData?.status) && (
                                                                                        <>
                                                                                          <br />
                                                                                          Reason : {errorMessage !== "" ? errorMessage : "Reason not mentioned by the gateway"}
                                                                                        </>
                                                                                      )}
                                                                                    </p>
                                                                                  )}

                                                                                  <div className="">
                                                                                    {hisData?.status == "CHARGEBACK" &&
                                                                                      index != 0 && (
                                                                                        <div className="">
                                                                                          <p>
                                                                                            Status change from{" "}
                                                                                            {hisData?.previous_status} to{" "}
                                                                                            {hisData?.status} at{" "}
                                                                                            {hisData?.status_changed_date} by{" "}
                                                                                            {hisData?.client
                                                                                              ? `System Api Call ${
                                                                                                  roleData?.[0]?.payment
                                                                                                    ?.value
                                                                                                    ?.payment_show_method_name
                                                                                                    ? hisData?.gateway_name
                                                                                                    : transaction?.gateway_id || ""
                                                                                                }`
                                                                                              : `${
                                                                                                  hisData?.first_name || ""
                                                                                                } ${
                                                                                                  hisData?.last_name || ""
                                                                                                }`}
                                                                                          </p>
                                                                                          <p>
                                                                                            ARN Number : {hisData?.arn || "-"}
                                                                                          </p>
                                                                                          <p>
                                                                                            Charge Back Reason :{" "}
                                                                                            {hisData?.reason || "-"}
                                                                                          </p>
                                                                                        </div>
                                                                                      )}
                                                                                    {hisData?.status != "CHARGEBACK" &&
                                                                                      index != 0 && (
                                                                                        <p className=" ">
                                                                                          Status change from{" "}
                                                                                          {hisData?.previous_status} to{" "}
                                                                                          {hisData?.status} at{" "}
                                                                                          {hisData?.status_changed_date} by{" "}
                                                                                          {hisData?.client
                                                                                            ? `System Api Call ${
                                                                                                roleData?.[0]?.payment?.value
                                                                                                  ?.payment_show_method_name
                                                                                                  ? hisData?.gateway_name
                                                                                                  : transaction?.gateway_id || ""
                                                                                              }`
                                                                                            : `${hisData?.first_name || ""} ${
                                                                                                hisData?.last_name || ""
                                                                                              }`}

                                                                                              
                                                                                            {["DECLINED", "ERRORED", "FAILED"].includes(hisData?.status) && (
                                                                                              <>
                                                                                                <br />
                                                                                                Reason : {errorMessage !== "" ? errorMessage : "Reason not mentioned by the gateway"}
                                                                                              </>
                                                                                            )}
                                                                                          {/* Status change from {hisData?.previous_status} to {hisData?.status} at {hisData?.status_changed_date} by {hisData?.client ? `System Api Call  ${hisData?.first_name || ""} ${hisData?.last_name || ""}` : ""} */}
                                                                                        </p>
                                                                                      )}
                                                                                  </div>
                                                                                </div>
                                                                              </Card>
                                                                            </>
                                                                          );
                                                                        }
                                                                      )
                                                                    ) : (
                                                                      <span className="">No history available.</span>
                                                                    )
                                                                  }
                                                                  trigger={
                                                                    <button className="flex items-center gap-1.5">
                                                                      <StatusRender
                                                                        status={transaction?.status}
                                                                        value={transaction?.status}
                                                                      />
                                                                    </button>
                                                                  }
                                                                  header={"Status History"}
                                                                />
                                                              </div>
                                                            </td>
                                                            <td className="min-w-[150px] border-white/0 py-3  pr-4 p-2 font-bold text-gray-900">
                                                              <AdvancedInfoModal
                                                                info={transaction}
                                                                client_is_deleted={false}
                                                              />
                                                            </td>

                                                          </tr>
                                                        ))}
                                                      </tbody> 
                                                    </table>
                                                  </div>
                                                </td>
                                              </tr>
                                            )}
                                          </React.Fragment>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              ) : (
                                <div className="border rounded-lg p-3 bg-white shadow">
                                  <p className="font-bold text-navy-700 text-center">No transactions available.</p>
                                </div>
                              )}
                              <h4 className="font-bold text-navy-700">Payment Methods</h4>
                              {Object.keys(row.original.paymentMethods).length > 0 ? (
                                <div className="border rounded-lg p-3 bg-white shadow">
                                  <table className="w-full w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 ">
                                    <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 ">
                                      <tr>
                                        <th className="border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2">
                                          <div className="items-center justify-between text-xs text-gray-200 ">
                                            <p className="text-sm font-bold text-gray-900 dark:text-white">Payment Method Type</p>
                                          </div>
                                        </th>
                                        <th className="border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2">
                                          <div className="items-center justify-between text-xs text-gray-200 ">
                                            <p className="text-sm font-bold text-gray-900 dark:text-white">No Of Payment Methods</p>
                                          </div>
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody >
                                      {Object.entries(row.original.paymentMethods).map(([methodId, methods]: [string, any]) => (
                                        <React.Fragment key={methodId}>
                                          <tr key={methodId}  className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 ">
                                            <td className="min-w-[150px] border-white/0 py-3  pr-4 p-2 font-bold text-gray-900">
                                              <div className="flex items-center gap-2 cursor-pointer capitalize" onClick={() => openPaymentMethods(methodId + ":" + row.original.customer_id)}>
                                                {activePaymentMethod === (methodId + ":" + row.original.customer_id) ? (
                                                  <>
                                                    <AiFillMinusCircle className="w-5 h-5 text-navy-700 dark:text-white " /> {methodId}
                                                  </>
                                                ) : (
                                                  <>
                                                    <AiFillPlusCircle className="w-5 h-5 text-navy-700 dark:text-white" /> {methodId}
                                                  </>
                                                )}
                                              </div>
                                            </td>
                                            <td className="min-w-[150px] border-white/0 py-3  pr-4 p-2 font-bold text-gray-900">
                                              {methods.length}
                                            </td>
                                          </tr>
                                          {activePaymentMethod === (methodId + ":" + row.original.customer_id) && (
                                            <tr>
                                              <td colSpan={3} className="p-4 text-gray-900 dark:text-white">
                                                <div className="space-y-2">
                                                  <table className="w-full w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 ">
                                                    <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 ">
                                                      <tr>
                                                        <th className="border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2">
                                                          <div className="items-center justify-between text-xs text-gray-200 ">
                                                            <p className="text-sm font-bold text-gray-900 dark:text-white">Created Date</p>
                                                          </div>
                                                        </th>
                                                        <th className="border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2">
                                                          <div className="items-center justify-between text-xs text-gray-200 ">
                                                            <p className="text-sm font-bold text-gray-900 dark:text-white">Payment method id</p>
                                                          </div>
                                                        </th>
                                                        {methodId === 'card' && (
                                                          <>
                                                            <th className="border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2">
                                                              <div className="items-center justify-between text-xs text-gray-200">
                                                                <p className="text-sm font-bold text-gray-900 dark:text-white">Last 4</p>
                                                              </div>
                                                            </th>
                                                            <th className="border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2">
                                                              <div className="items-center justify-between text-xs text-gray-200">
                                                                <p className="text-sm font-bold text-gray-900 dark:text-white">Card Type</p>
                                                              </div>
                                                            </th>
                                                          </>
                                                        )}
                                                        {methodId === 'bank' && (
                                                          <>
                                                            <th className="border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2">
                                                              <div className="items-center justify-between text-xs text-gray-200">
                                                                <p className="text-sm font-bold text-gray-900 dark:text-white">Iban</p>
                                                              </div>
                                                            </th>
                                                            <th className="border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2">
                                                              <div className="items-center justify-between text-xs text-gray-200">
                                                                <p className="text-sm font-bold text-gray-900 dark:text-white">Swift No</p>
                                                              </div>
                                                            </th>
                                                            <th className="border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2">
                                                              <div className="items-center justify-between text-xs text-gray-200">
                                                                <p className="text-sm font-bold text-gray-900 dark:text-white">Bank ID</p>
                                                              </div>
                                                            </th>
                                                            <th className="border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2">
                                                              <div className="items-center justify-between text-xs text-gray-200">
                                                                <p className="text-sm font-bold text-gray-900 dark:text-white">Account Number</p>
                                                              </div>
                                                            </th>
                                                            <th className="border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2">
                                                              <div className="items-center justify-between text-xs text-gray-200">
                                                                <p className="text-sm font-bold text-gray-900 dark:text-white">Account Type</p>
                                                              </div>
                                                            </th>
                                                            <th className="border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2">
                                                              <div className="items-center justify-between text-xs text-gray-200">
                                                                <p className="text-sm font-bold text-gray-900 dark:text-white">Bank Name</p>
                                                              </div>
                                                            </th>
                                                            <th className="border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2">
                                                              <div className="items-center justify-between text-xs text-gray-200">
                                                                <p className="text-sm font-bold text-gray-900 dark:text-white">Bank Branch</p>
                                                              </div>
                                                            </th>
                                                          </>
                                                        )}
                                                        {methodId === 'crypto' && (
                                                          <>
                                                            <th className="border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2">
                                                              <div className="items-center justify-between text-xs text-gray-200">
                                                                <p className="text-sm font-bold text-gray-900 dark:text-white">Wallet Address</p>
                                                              </div>
                                                            </th>
                                                          </>
                                                        )}
                                                      </tr>
                                                    </thead>
                                                    <tbody >
                                                      {methods.map((meth : any, index : any) => (
                                                        <tr key={index} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                                                          <td className="min-w-[150px] border-white/0 py-3 pr-4 p-2 font-bold text-gray-900">
                                                            {meth.created_at ? moment(meth.created_at).format("YYYY-MM-DD HH:mm:ss") : "No Date Available"}
                                                          </td>
                                                          <td className="min-w-[150px] border-white/0 py-3 pr-4 p-2 font-bold text-gray-900">
                                                            <ShortTruncateCopy info={meth.payment_method_id} showCopy={true} />
                                                          </td>
                                                          {methodId === 'card' && (
                                                            <>
                                                              <td className="min-w-[150px] border-white/0 py-3 pr-4 p-2 font-bold text-gray-900">
                                                                {meth.card_number?.slice(-4)}
                                                              </td>
                                                              <td className="min-w-[150px] border-white/0 py-3 pr-4 p-2 font-bold text-gray-900">
                                                                {getCardSVG(getCardType(meth.card_number))}
                                                              </td>
                                                            </>
                                                          )}
                                                          {methodId === 'bank' && (
                                                            <>
                                                              <td className="min-w-[150px] border-white/0 py-3 pr-4 p-2 font-bold text-gray-900">
                                                                {meth.iban || "-"}
                                                              </td>
                                                              <td className="min-w-[150px] border-white/0 py-3 pr-4 p-2 font-bold text-gray-900">
                                                                {meth.swift_no  || "-"}
                                                              </td>
                                                              <td className="min-w-[150px] border-white/0 py-3 pr-4 p-2 font-bold text-gray-900">
                                                                {meth.bank_id  || "-"}
                                                              </td>
                                                              <td className="min-w-[150px] border-white/0 py-3 pr-4 p-2 font-bold text-gray-900">
                                                                {meth.account_number  || "-"}
                                                              </td>
                                                              <td className="min-w-[150px] border-white/0 py-3 pr-4 p-2 font-bold text-gray-900">
                                                                {meth.account_type  || "-"}
                                                              </td>
                                                              <td className="min-w-[150px] border-white/0 py-3 pr-4 p-2 font-bold text-gray-900">
                                                                {meth.bank_name  || "-"}
                                                              </td>
                                                              <td className="min-w-[150px] border-white/0 py-3 pr-4 p-2 font-bold text-gray-900">
                                                                {meth.bank_branch  || "-"}
                                                              </td>
                                                            </>
                                                          )}
                                                          {methodId === 'crypto' && (
                                                            <>
                                                              <td className="min-w-[150px] border-white/0 py-3 pr-4 p-2 font-bold text-gray-900">
                                                                <ShortTruncateCopy info={meth.wallet_address} showCopy={true} />
                                                              </td>
                                                            </>
                                                          )}
                                                        </tr>
                                                      ))}
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </td>
                                            </tr>
                                          )}
                                        </React.Fragment>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              ) : (
                                <div className="border rounded-lg p-3 bg-white shadow">
                                  <p className="font-bold text-navy-700 text-center">No payment methods available.</p>
                                </div>
                              )}
                              <h4 className="font-bold text-navy-700">KYC</h4>
                              {Object.keys(row.original.kyc).length > 0 ? (
                                <div className="border rounded-lg p-3 bg-white shadow">
                                  <table className="w-full w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 ">
                                  <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 ">
                                      <tr>
                                        <th className="border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2">
                                          <div className="items-center justify-between text-xs text-gray-200 ">
                                            <p className="text-sm font-bold text-gray-900 dark:text-white">Created Date</p>
                                          </div>
                                        </th>
                                        <th className="border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2">
                                          <div className="items-center justify-between text-xs text-gray-200 ">
                                            <p className="text-sm font-bold text-gray-900 dark:text-white">KYC id</p>
                                          </div>
                                        </th>
                                        <th className="border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2">
                                          <div className="items-center justify-between text-xs text-gray-200 ">
                                            <p className="text-sm font-bold text-gray-900 dark:text-white">Identification Number</p>
                                          </div>
                                        </th>
                                        <th className="border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2">
                                          <div className="items-center justify-between text-xs text-gray-200 ">
                                            <p className="text-sm font-bold text-gray-900 dark:text-white">Identification Type</p>
                                          </div>
                                        </th>
                                        <th className="border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2">
                                          <div className="items-center justify-between text-xs text-gray-200 ">
                                            <p className="text-sm font-bold text-gray-900 dark:text-white">Identification Issued At</p>
                                          </div>
                                        </th>
                                        <th className="border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2">
                                          <div className="items-center justify-between text-xs text-gray-200 ">
                                            <p className="text-sm font-bold text-gray-900 dark:text-white">Identification Expired At</p>
                                          </div>
                                        </th>
                                        <th className="border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2">
                                          <div className="items-center justify-between text-xs text-gray-200 ">
                                            <p className="text-sm font-bold text-gray-900 dark:text-white">Status</p>
                                          </div>
                                        </th>
                                        {(
                                          roleData?.[0]?.customers?.value?.upload_kyc_document || 
                                          roleData?.[0]?.customers?.value?.view_kyc_document
                                        ) && (
                                          <th className="border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start p-2">
                                            <div className="items-center justify-between text-xs text-gray-200 ">
                                              <p className="text-sm font-bold text-gray-900 dark:text-white">Action</p>
                                            </div>
                                          </th>
                                        )}
                                      </tr>
                                    </thead>
                                    <tbody >
                                      {Object.entries(row.original.kyc).map(([key, kyc_data]: [string, any]) => {
                                        return (
                                          <React.Fragment key={key}>
                                            <tr key={key} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                                              <td className="min-w-[150px] border-white/0 py-3 pr-4 p-2 font-bold text-gray-900">
                                                {kyc_data.created_date ? moment(kyc_data.created_date).format("YYYY-MM-DD HH:mm:ss") : "No Date Available"}
                                              </td>
                                              <td className="min-w-[150px] border-white/0 py-3 pr-4 p-2 font-bold text-gray-900">
                                                <ShortTruncateCopy info={kyc_data.kyc_id} showCopy={true} />
                                              </td>
                                              <td className="min-w-[150px] uppercase border-white/0 py-3 pr-4 p-2 font-bold text-gray-900">
                                                {kyc_data.identification_number}
                                              </td>
                                              <td className="min-w-[150px] uppercase border-white/0 py-3 pr-4 p-2 font-bold text-gray-900">
                                                {kyc_data.identification_type}
                                              </td>
                                              <td className="min-w-[150px] uppercase border-white/0 py-3 pr-4 p-2 font-bold text-gray-900">
                                                {kyc_data.document_issued_at || "-"}
                                              </td>
                                              <td className="min-w-[150px] uppercase border-white/0 py-3 pr-4 p-2 font-bold text-gray-900">
                                                {kyc_data.document_expired_at || "-"}
                                              </td>
                                              <td className="min-w-[150px] uppercase border-white/0 py-3 pr-4 p-2 font-bold text-gray-900">
                                                {kyc_data.status === 'verified' ? (
                                                  <p className="w-fit rounded-lg bg-teal-100 px-2 py-1 text-sm font-bold text-teal-700 dark:bg-teal-50 dark:text-white">
                                                    <span className="text-center uppercase text-teal-500">
                                                      Verified
                                                    </span>
                                                  </p>
                                                ) : (
                                                  <p className="w-fit rounded-lg bg-red-100 px-2 py-1 text-sm font-bold text-red-700 dark:bg-red-50 dark:text-white">
                                                    <span className="text-center uppercase text-red-500">
                                                      Unverified
                                                    </span>
                                                  </p>
                                                )}
                                              </td>
                                              {(
                                                roleData?.[0]?.customers?.value?.upload_kyc_document || 
                                                roleData?.[0]?.customers?.value?.view_kyc_document
                                              ) && (
                                                <td className="min-w-[150px] uppercase border-white/0 py-3 pr-4 p-2 font-bold text-gray-900">
                                                  <div className="flex items-center gap-2">
                                                    {roleData?.[0]?.customers?.value?.upload_kyc_document && (
                                                      kyc_data.document === '' || kyc_data.document === null ? (
                                                        uploadingKYC === kyc_data.kyc_id ? (
                                                          <div className="relative w-full h-full flex ">
                                                          <div className={`animate-spin rounded-full border-2 border-t-0 border-b-0 h-6 w-6 border-indigo-500`}></div>
                                                          </div>
                                                        ) : (
                                                          <>
                                                            <Popover trigger="hover" placement="bottom">
                                                              <PopoverTrigger>
                                                                <label htmlFor={`file-upload-${key}`} className="cursor-pointer">
                                                                  <input
                                                                    type="file"
                                                                    accept="image/*,application/pdf"
                                                                    style={{ display: "none" }}
                                                                    id={`file-upload-${key}`}
                                                                    onChange={(e) =>
                                                                      handleFileChange(e, kyc_data.kyc_id, row.original.customer_id)
                                                                    }
                                                                  />
                                                                  <FiUpload size={20} className="text-blue-600 hover:text-blue-800" />
                                                                </label>
                                                              </PopoverTrigger>  
                                                              <Portal > 
                                                                <PopoverContent borderColor='blue.800' className="z-20 dark:bg-gray-800 shadow  invisible inline-block text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-lg shadow-sm opacity-0 dark:text-gray-400 dark:border-gray-600 dark:bg-gray-800 p-3 border-6 shadow !bg-gray-700">
                                                                  <PopoverHeader>
                                                                    <span className="text-sm  font-bold text-white">
                                                                  Choose Document to Upload
                                                                  </span>
                                                                  </PopoverHeader>
                                                                  <PopoverArrow  className="border h-8 w-8 border-gray-700 !bg-gray-700  "  />
                                                                </PopoverContent>
                                                              </Portal>
                                                            </Popover>
                                                          </>
                                                        )
                                                      ) : (
                                                        <>
                                                          <Popover trigger="hover" placement="bottom">
                                                            <PopoverTrigger>
                                                              <span>
                                                                <FiCheckCircle size={20} className="text-blue-600 hover:text-blue-800"/>
                                                              </span>
                                                            </PopoverTrigger>  
                                                            <Portal > 
                                                              <PopoverContent borderColor='blue.800' className="z-20 dark:bg-gray-800 shadow  invisible inline-block text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-lg shadow-sm opacity-0 dark:text-gray-400 dark:border-gray-600 dark:bg-gray-800 p-3 border-6 shadow !bg-gray-700">
                                                                <PopoverHeader>
                                                                  <span className="text-sm  font-bold text-white">
                                                                Document Uploaded
                                                                </span>
                                                                </PopoverHeader>
                                                                <PopoverArrow  className="border h-8 w-8 border-gray-700 !bg-gray-700  "  />
                                                              </PopoverContent>
                                                            </Portal>
                                                          </Popover>
                                                        </>
                                                      )
                                                    )}
                                                    {roleData?.[0]?.customers?.value?.view_kyc_document && kyc_data.status === 'verified' && kyc_data.document && (
                                                      <>
                                                          <Popover trigger="hover" placement="bottom">
                                                            <PopoverTrigger>
                                                              <button
                                                                onClick={() => {
                                                                  const [meta, base64Data] = kyc_data.document.split(',');
                                                                  const mime = meta.match(/data:(.*);base64/)[1];

                                                                  const byteChars = atob(base64Data);
                                                                  const byteArray = new Uint8Array(byteChars.length);
                                                                  for (let i = 0; i < byteChars.length; i++) {
                                                                    byteArray[i] = byteChars.charCodeAt(i);
                                                                  }

                                                                  const blob = new Blob([byteArray], { type: mime });
                                                                  const blobUrl = URL.createObjectURL(blob);
                                                                  window.open(blobUrl, '_blank');
                                                                }}
                                                                className="cursor-pointer"
                                                              >
                                                                <FiEye size={20} className="text-blue-600 hover:text-blue-800"/>
                                                              </button>
                                                            </PopoverTrigger>  
                                                            <Portal > 
                                                              <PopoverContent borderColor='blue.800' className="z-20 dark:bg-gray-800 shadow  invisible inline-block text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-lg shadow-sm opacity-0 dark:text-gray-400 dark:border-gray-600 dark:bg-gray-800 p-3 border-6 shadow !bg-gray-700">
                                                                <PopoverHeader>
                                                                  <span className="text-sm  font-bold text-white">
                                                                View Document
                                                                </span>
                                                                </PopoverHeader>
                                                                <PopoverArrow  className="border h-8 w-8 border-gray-700 !bg-gray-700  "  />
                                                              </PopoverContent>
                                                            </Portal>
                                                          </Popover>
                                                        </>
                                                      
                                                    )}
                                                  </div>
                                                </td>
                                              )}
                                            </tr>
                                          </React.Fragment>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                </div>
                              ) : (
                                <div className="border rounded-lg p-3 bg-white shadow">
                                  <p className="font-bold text-navy-700 text-center">No KYC data available.</p>
                                </div>
                              )}

                              </>
                            

                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                }) :
  
                  <tr>
                    <td colSpan={6} >
                      <p className="text-center p-4" >No records found.</p>
                    </td>
  
                  </tr>
  
                }
  
  
              </tbody>
            </table>
          )}
        </div>
  
        <Pagination
          setPage={setPage}
          page={page}
          totalpage={totalpage}
          currentPage={currentPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          arraySize={[50, 100, 200]}
        />
      </Card>
    );
  }
  
  export default CustomerTable;
  const columnHelper = createColumnHelper<ClientRowObj>();
  